import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  const theme = useTheme();
  const PRIMARY_LIGHT = theme.palette.primary.light;
  const PRIMARY_MAIN = theme.palette.primary.main;
  const PRIMARY_DARK = theme.palette.primary.dark;
  const logo = (
    <Box sx={{ width: 40, height: 40, ...sx }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%"  viewBox="0 0 1080.000000 791.000000">
        <defs>
          <linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
            <stop offset="0%" stopColor={PRIMARY_DARK} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
        </defs>
        <g
          fill={PRIMARY_MAIN} stroke="none" strokeWidth="1" fillRule="evenodd"  transform="translate(0.000000,791.000000) scale(0.100000,-0.100000)">
	<path d="M0 3955 l0 -3955 5400 0 5400 0 0 3955 0 3955 -5400 0 -5400 0 0
-3955z m5836 2790 c470 -64 879 -267 1238 -615 430 -417 710 -983 801 -1623
65 -452 22 -949 -120 -1382 -73 -221 -189 -465 -312 -655 -195 -300 -477 -581
-754 -750 -82 -51 -94 -55 -56 -20 l22 21 -27 -10 c-19 -7 -28 -7 -30 1 -3 8
-10 8 -25 -1 -12 -6 -37 -11 -56 -11 -18 0 -37 -3 -41 -8 -4 -4 -20 -7 -34 -8
-15 0 -56 -4 -92 -8 l-65 -8 165 84 c184 94 290 160 387 240 269 221 485 490
643 802 97 192 109 221 165 391 51 154 96 354 121 540 21 149 24 505 6 660
-42 360 -142 689 -304 995 -46 88 -201 331 -230 362 -7 7 -33 38 -58 68 -297
363 -735 635 -1159 720 -53 10 -165 27 -250 37 -98 11 -145 20 -130 24 23 7
22 7 -6 9 l-30 2 30 8 c29 7 29 8 5 10 -18 2 -20 4 -7 7 10 3 18 15 19 31 4
72 3 82 -7 83 -15 1 37 17 61 18 11 1 69 -6 130 -14z m-366 -5 c-30 -4 -48 -8
-40 -9 13 -1 13 -2 0 -11 -10 -6 -11 -10 -2 -10 7 0 12 -15 12 -39 0 -22 3
-41 8 -44 4 -2 2 -2 -5 -1 -6 2 -14 -4 -17 -12 -5 -12 -1 -14 17 -8 l22 6 -23
-20 c-26 -23 -189 -57 -225 -47 -14 4 -17 3 -10 -2 8 -6 -14 -14 -62 -22 -41
-7 -77 -16 -80 -22 -9 -14 -27 -11 -20 4 4 6 0 3 -9 -7 -8 -10 -28 -19 -45
-20 -16 -1 -27 -4 -24 -8 2 -5 -2 -8 -10 -8 -23 0 -241 -105 -341 -164 -198
-117 -439 -324 -596 -511 -232 -278 -419 -659 -509 -1035 -53 -222 -72 -368
-78 -600 -13 -474 71 -879 274 -1317 8 -18 12 -37 8 -42 -3 -6 -1 -19 5 -28 9
-16 10 -15 5 5 -11 39 9 23 32 -25 35 -76 172 -289 215 -335 14 -16 28 -33 30
-37 2 -5 37 -46 78 -92 76 -84 85 -99 62 -107 -7 -2 -12 0 -11 5 3 12 -12 43
-21 43 -10 0 17 -57 30 -65 4 -3 11 2 14 11 7 17 21 7 111 -75 117 -106 249
-205 324 -243 25 -13 48 -26 51 -29 19 -23 259 -129 375 -166 20 -6 30 -16 30
-29 0 -10 5 -22 10 -26 6 -5 5 -8 -2 -8 -9 0 -13 -16 -13 -45 0 -36 4 -45 18
-46 13 0 14 -2 2 -6 -8 -3 -18 -10 -21 -16 -4 -5 -13 -6 -20 -2 -10 7 -8 10 7
17 13 5 9 6 -13 2 -44 -7 -103 5 -103 22 0 9 -11 14 -27 14 -16 0 -55 12 -88
26 -33 14 -65 26 -72 27 -7 0 -14 6 -17 14 -3 7 -13 13 -23 13 -10 0 -60 25
-112 55 -51 30 -97 55 -102 55 -5 0 -9 5 -9 10 0 6 -7 10 -16 10 -8 0 -13 4
-9 9 3 6 -4 15 -15 21 -11 6 -20 8 -20 4 0 -3 -15 5 -34 20 -19 14 -37 26 -39
26 -5 0 -67 52 -104 88 -13 12 -25 22 -27 22 -16 0 -66 59 -66 77 0 27 -17 40
-22 16 -3 -16 -6 -15 -27 6 -16 16 -20 26 -13 29 7 2 12 11 11 20 0 11 -2 12
-6 5 -7 -20 -19 -15 -31 12 -6 14 -20 25 -30 25 -10 0 -25 11 -32 25 -7 14
-19 25 -27 25 -7 0 -13 7 -13 15 0 8 -7 15 -15 15 -8 0 -15 4 -15 9 0 10 -50
77 -80 108 -16 16 -21 29 -16 48 4 14 2 25 -4 25 -5 0 -10 -5 -10 -10 0 -6 -7
-6 -18 1 -17 11 -52 77 -52 98 0 5 -5 11 -11 13 -7 2 -12 45 -15 116 -2 62 -8
120 -14 130 -10 15 -11 14 -7 -5 4 -18 1 -23 -14 -23 -10 0 -19 -5 -19 -11 0
-6 -9 -8 -20 -4 -24 7 -26 -7 -5 -25 8 -7 14 -18 13 -24 -2 -6 8 -26 21 -44
13 -18 20 -36 17 -39 -7 -8 -5 -10 -44 55 -18 29 -32 61 -32 72 0 11 -6 20
-12 21 -10 0 -10 2 0 6 7 3 11 20 11 41 -1 24 -3 29 -6 15 -6 -30 -25 -30 -21
0 1 12 -2 22 -7 22 -6 0 -9 -6 -7 -12 6 -27 -8 -11 -27 30 -50 113 -59 137
-50 137 5 0 9 -5 9 -11 0 -8 5 -8 15 1 8 7 14 22 14 34 -2 20 -2 20 -6 -1 -2
-13 -9 -23 -14 -23 -5 0 -9 10 -9 23 -1 21 -1 21 -12 3 -9 -16 -13 -12 -29 35
-10 30 -23 63 -28 74 -27 63 -71 223 -71 260 0 13 -5 36 -12 50 -10 22 -9 28
2 35 12 7 12 10 -2 15 -25 10 -29 30 -18 106 6 39 7 76 3 82 -5 7 -11 -5 -14
-28 -6 -33 -6 -31 -4 13 3 49 -9 73 -18 35 -4 -22 -17 110 -25 279 -8 144 3
433 19 517 6 31 14 88 19 126 5 39 11 79 14 90 3 11 19 79 37 150 17 72 37
145 45 164 8 18 14 40 14 48 0 8 9 32 19 54 11 22 23 54 27 72 3 17 10 38 15
47 21 38 99 212 99 220 0 20 19 9 23 -12 2 -13 3 -8 1 11 -2 25 8 53 42 112
25 44 50 79 55 79 5 0 8 3 8 8 -6 35 17 44 25 10 2 -13 4 -7 3 13 -2 30 0 35
15 31 19 -5 26 14 8 20 -12 4 10 58 23 58 4 0 7 6 7 13 0 7 8 20 18 28 29 27
47 53 78 110 42 79 259 294 434 432 88 70 278 174 360 198 25 7 50 18 55 24
24 26 262 113 332 122 26 3 53 9 58 13 15 11 100 32 116 29 8 -2 31 3 52 10
22 7 53 10 70 7 23 -4 28 -3 17 4 -10 7 11 9 70 8 80 -1 82 -2 30 -8z m113
-137 c-13 -2 -33 -2 -45 0 -13 2 -3 4 22 4 25 0 35 -2 23 -4z m-66 -19 c-3 -3
-12 -4 -19 -1 -8 3 -5 6 6 6 11 1 17 -2 13 -5z m293 -448 c-12 -12 -13 11 -2
120 l7 79 3 -94 c2 -56 -1 -98 -8 -105z m-312 145 c35 -22 74 -48 87 -59 13
-11 32 -25 44 -31 11 -6 19 -20 18 -31 -1 -22 1 -21 -162 -40 -55 -7 -107 -16
-116 -21 -9 -4 -35 -10 -58 -11 -22 -2 -41 -6 -41 -9 0 -4 -17 -10 -37 -14
-47 -8 -243 -84 -264 -102 -8 -7 -20 -13 -25 -13 -8 0 -41 -19 -168 -98 -5 -3
-7 2 -3 11 8 20 -4 22 -21 5 -8 -8 -15 -9 -20 -3 -4 6 -32 10 -62 11 -69 0
-160 8 -160 13 0 11 89 86 155 131 28 18 52 36 55 40 3 3 65 36 137 73 143 73
344 150 368 140 9 -3 21 -1 28 4 18 14 86 32 132 36 22 2 42 4 45 5 3 1 34
-16 68 -37z m642 -31 c0 -5 -5 -10 -11 -10 -5 0 -7 5 -4 10 3 6 8 10 11 10 2
0 4 -4 4 -10z m125 -28 c-3 -3 -11 0 -18 7 -9 10 -8 11 6 5 10 -3 15 -9 12
-12z m42 -18 c-3 -3 -12 -4 -19 -1 -8 3 -5 6 6 6 11 1 17 -2 13 -5z m262 -132
c-9 -4 -169 86 -169 94 0 3 40 -17 89 -43 49 -26 85 -50 80 -51z m-119 8 c0
-5 -4 -10 -10 -10 -5 0 -10 5 -10 10 0 6 5 10 10 10 6 0 10 -4 10 -10z m193
-50 c26 -16 47 -31 47 -33 0 -5 -42 -1 -77 7 -18 4 -33 12 -33 17 0 12 17 12
24 0 8 -12 46 -21 46 -10 0 5 -17 17 -37 28 -21 11 -33 20 -27 21 5 0 31 -13
57 -30z m283 -233 c58 -55 145 -153 195 -218 88 -116 120 -168 88 -142 -8 6
-51 14 -97 18 -67 6 -85 12 -97 28 -8 11 -11 25 -8 30 4 6 0 8 -9 4 -11 -4
-21 6 -34 33 -13 26 -23 36 -34 32 -8 -3 -12 -2 -9 2 4 4 -9 23 -28 42 -18 19
-31 39 -28 44 3 5 -5 10 -17 12 -13 2 -23 10 -23 18 0 9 -11 26 -23 38 -13 13
-20 28 -16 34 5 7 10 4 15 -10 10 -27 25 -28 39 -2 8 15 8 18 -3 14 -16 -6
-90 40 -80 50 3 3 13 0 21 -7 12 -9 16 -9 19 1 3 6 12 12 21 13 11 0 12 2 5 6
-15 5 -17 23 -4 23 5 0 13 -9 16 -20 3 -11 15 -20 26 -20 19 0 21 -4 23 -45 1
-15 8 -20 26 -19 14 1 30 -6 36 -14 7 -10 13 -11 17 -5 4 6 -3 18 -16 26 -12
8 -53 44 -90 81 -38 36 -71 66 -75 66 -9 1 -62 47 -62 55 0 13 111 -77 206
-168z m-333 108 c30 7 31 6 12 -8 -27 -21 -65 -3 -56 27 6 21 6 21 9 -2 3 -20
7 -22 35 -17z m142 -85 c3 -5 1 -10 -4 -10 -6 0 -11 5 -11 10 0 6 2 10 4 10 3
0 8 -4 11 -10z m-21 -16 c9 -24 7 -28 -9 -14 -17 14 -20 30 -6 30 5 0 12 -7
15 -16z m46 -24 c8 -5 11 -12 8 -16 -10 -9 -38 3 -38 16 0 12 10 13 30 0z
m155 -10 c3 -5 -1 -10 -9 -10 -9 0 -16 5 -16 10 0 6 4 10 9 10 6 0 13 -4 16
-10z m-1010 -545 c72 -18 172 -86 222 -150 53 -67 97 -177 97 -237 0 -27 3
-48 7 -48 4 0 7 -16 7 -35 0 -19 -4 -35 -10 -35 -5 0 -7 -4 -4 -8 7 -11 -17
-96 -40 -147 -28 -60 -94 -146 -106 -138 -6 3 -8 1 -5 -4 9 -15 -19 -37 -93
-74 -52 -26 -78 -32 -130 -33 -71 0 -87 3 -154 33 -81 35 -148 101 -196 191
-20 37 -4 21 35 -35 20 -30 39 -55 41 -55 7 0 185 85 402 192 l224 111 -7 50
c-10 68 -39 150 -72 203 -28 44 -41 52 -58 35 -6 -5 -44 -21 -85 -35 -82 -29
-93 -33 -160 -64 -59 -27 -278 -112 -289 -112 -16 0 8 165 34 233 13 31 -14
18 -40 -20 -28 -42 -35 -38 -8 5 63 100 146 164 235 181 65 13 92 12 153 -4z
m1370 -16 c-22 -6 -15 -7 25 -3 l55 5 18 -38 c31 -64 88 -205 109 -268 10 -33
23 -69 28 -80 32 -73 86 -347 101 -506 14 -156 6 -509 -15 -644 -22 -136 -68
-321 -112 -452 -55 -161 -214 -481 -244 -491 -7 -3 -10 0 -6 7 4 6 2 11 -3 11
-6 0 -11 -4 -11 -8 0 -5 -24 -9 -52 -9 -45 0 -47 1 -11 4 23 2 47 11 53 19 9
10 9 14 1 14 -6 0 -11 -4 -11 -10 0 -5 -21 -9 -47 -8 -37 1 -41 2 -15 5 29 4
31 6 17 19 -20 21 -19 28 9 61 13 15 26 38 30 50 4 12 25 55 47 94 21 39 39
77 39 83 0 7 4 16 8 22 5 5 28 56 50 114 36 91 57 166 113 400 21 91 49 348
49 460 1 105 2 113 15 90 13 -23 14 -23 15 -4 0 20 46 72 58 66 4 -2 8 3 10
11 2 10 -4 13 -20 10 -14 -3 -32 4 -45 17 -15 13 -23 16 -24 8 -2 -42 -29 64
-39 157 -6 61 -16 118 -21 128 -6 10 -10 44 -10 75 -1 31 -4 59 -8 62 -7 4
-37 89 -70 192 -7 21 -9 43 -5 49 4 7 3 9 -3 6 -6 -4 -20 16 -33 46 -12 28
-27 55 -32 58 -5 3 -10 22 -11 41 -1 20 -5 34 -9 31 -5 -2 -8 2 -8 10 0 8 -9
22 -20 32 -11 10 -20 25 -20 33 0 8 -8 21 -17 28 -16 12 -10 13 42 12 50 0 55
-2 30 -9z m-1783 -231 c-7 -7 -12 -8 -12 -2 0 14 12 26 19 19 2 -3 -1 -11 -7
-17z m-20 -45 c-3 -16 -7 -22 -10 -15 -4 13 4 42 11 42 2 0 2 -12 -1 -27z
m615 -25 c-2 -13 -4 -5 -4 17 -1 22 1 32 4 23 2 -10 2 -28 0 -40z m-630 -40
c-3 -7 -5 -2 -5 12 0 14 2 19 5 13 2 -7 2 -19 0 -25z m640 -50 c-3 -8 -6 -5
-6 6 -1 11 2 17 5 13 3 -3 4 -12 1 -19z m-592 2 c-3 -5 -11 -10 -16 -10 -6 0
-7 5 -4 10 3 6 11 10 16 10 6 0 7 -4 4 -10z m512 -22 c-3 -8 -6 -5 -6 6 -1 11
2 17 5 13 3 -3 4 -12 1 -19z m-547 8 c0 -2 -7 -6 -15 -10 -8 -3 -15 -1 -15 4
0 6 7 10 15 10 8 0 15 -2 15 -4z m437 -58 c-2 -13 -4 -3 -4 22 0 25 2 35 4 23
2 -13 2 -33 0 -45z m-450 -85 c-3 -10 -5 -4 -5 12 0 17 2 24 5 18 2 -7 2 -21
0 -30z m21 -58 c-3 -3 -9 2 -12 12 -6 14 -5 15 5 6 7 -7 10 -15 7 -18z m-1072
-29 c3 -8 0 -159 -6 -335 -9 -275 -14 -329 -31 -382 -23 -70 -56 -126 -96
-164 -57 -54 -66 -46 -14 11 85 93 97 130 107 339 2 61 6 146 8 190 3 44 5
142 5 218 1 87 5 137 11 137 6 0 13 -6 16 -14z m1454 -637 c58 -115 108 -209
111 -209 11 0 18 68 25 243 l7 167 36 -6 c20 -4 37 -8 39 -9 3 -3 -18 -547
-22 -560 -2 -6 -22 -9 -46 -7 l-42 4 -45 97 c-58 125 -143 293 -154 306 -6 5
-12 5 -18 0 -7 -8 -19 -229 -21 -382 0 -18 -5 -22 -22 -19 -13 3 -33 5 -45 5
-22 1 -23 5 -23 69 0 37 5 85 10 107 5 22 12 122 16 223 l7 182 41 -1 41 0
105 -210z m525 175 l80 -7 -3 -36 -4 -37 -89 4 -89 4 0 -81 0 -81 43 -2 c23
-1 59 -1 81 0 36 2 38 1 32 -20 -3 -13 -6 -33 -6 -45 0 -14 -6 -23 -16 -23 -8
0 -13 3 -11 8 3 4 -25 6 -61 6 l-67 -2 -3 -86 -3 -85 88 -3 88 -3 0 -35 0 -35
-134 -3 -134 -3 7 68 c5 52 23 401 26 491 0 14 50 15 175 6z m383 -21 l112 -6
0 -39 0 -38 -64 0 -64 0 -6 -187 c-4 -104 -9 -210 -12 -236 l-6 -48 -37 3
c-20 2 -35 8 -35 13 1 6 5 112 9 238 l7 227 -61 0 -61 0 0 40 0 40 53 0 c28 0
103 -3 165 -7z m375 -19 l107 -6 0 -39 0 -39 -59 0 -59 0 -6 -92 c-3 -51 -8
-155 -12 -231 l-6 -138 -37 3 c-33 3 -36 5 -35 33 1 17 4 121 9 232 l7 202
-58 3 c-56 3 -59 4 -62 31 -6 48 2 55 55 51 26 -2 96 -6 156 -10z m-1632 -347
c-10 -9 -11 -8 -5 6 3 10 9 15 12 12 3 -3 0 -11 -7 -18z m-231 -68 c0 -58 -3
-80 -12 -77 -6 2 -13 11 -16 19 -3 11 -2 11 7 -1 8 -11 11 5 11 63 0 42 2 77
5 77 3 0 5 -36 5 -81z m-9 -272 c-8 -8 -11 -7 -11 4 0 20 13 34 18 19 3 -7 -1
-17 -7 -23z m-352 13 c5 0 20 -12 35 -26 42 -43 33 -132 -17 -164 -31 -19 -97
-19 -98 0 0 10 -3 8 -9 -5 -5 -13 -7 10 -6 62 0 44 4 79 7 78 3 -2 3 9 1 25
-4 25 -1 29 24 33 16 2 35 2 42 0 8 -1 17 -3 21 -3z m219 -41 c23 -18 27 -19
30 -5 2 9 7 16 12 16 9 0 2 -170 -7 -180 -3 -3 -9 3 -14 13 -10 17 -12 16 -35
-2 l-26 -20 -24 24 c-13 13 -24 29 -24 35 0 5 -4 10 -8 10 -5 0 -9 13 -10 28
-1 29 36 82 57 82 6 0 11 5 11 10 0 15 9 12 38 -11z m166 3 c8 -13 -11 -35
-23 -28 -8 5 -11 -15 -11 -68 0 -42 -4 -76 -9 -76 -5 0 -8 30 -7 68 4 95 4 95
22 88 12 -4 15 -2 10 9 -6 15 9 21 18 7z m164 -4 c2 7 8 10 13 6 11 -7 0 -165
-12 -178 -6 -6 -9 -3 -9 7 0 20 -26 23 -33 5 -3 -10 -10 -10 -31 2 -15 8 -22
16 -16 18 7 3 16 -1 20 -8 5 -9 14 -6 34 11 20 17 26 32 26 62 0 37 -17 67
-39 67 -6 0 -11 4 -11 10 0 6 11 5 27 -3 21 -9 27 -9 31 1z m-92 -34 c-11 -10
-17 -31 -16 -53 1 -20 1 -40 0 -46 -2 -15 -18 27 -19 51 -1 22 37 79 46 70 3
-3 -2 -13 -11 -22z m1325 -7 c-10 -9 -11 -8 -5 6 3 10 9 15 12 12 3 -3 0 -11
-7 -18z m-122 -27 c0 -10 -3 -8 -9 5 -12 27 -12 43 0 25 5 -8 9 -22 9 -30z
m131 -63 c0 -5 -4 -5 -10 -2 -5 3 -10 14 -10 23 0 15 2 15 10 2 5 -8 10 -19
10 -23z m-150 -22 c0 -8 -2 -15 -4 -15 -2 0 -6 7 -10 15 -3 8 -1 15 4 15 6 0
10 -7 10 -15z m-2886 -535 c-4 -18 -2 -30 4 -30 5 0 8 -9 5 -20 -5 -19 -6 -19
-19 6 -22 42 -19 62 13 73 1 1 0 -12 -3 -29z m3410 -162 c-17 -29 -77 -98 -81
-94 -3 3 14 28 37 55 42 49 59 65 44 39z m-85 -111 c-2 -1 -15 -11 -29 -22
l-25 -20 19 23 c11 12 24 22 29 22 6 0 8 -1 6 -3z m-2969 -297 c0 -5 -2 -10
-4 -10 -3 0 -8 5 -11 10 -3 6 -1 10 4 10 6 0 11 -4 11 -10z m1147 -496 c-3 -3
-12 -4 -19 -1 -8 3 -5 6 6 6 11 1 17 -2 13 -5z m60 -10 c-3 -3 -12 -4 -19 -1
-8 3 -5 6 6 6 11 1 17 -2 13 -5z m273 -34 l85 -8 -100 0 c-55 0 -127 -3 -160
-6 -53 -6 -57 -6 -37 6 12 8 19 18 15 22 -4 5 19 5 52 1 33 -4 98 -11 145 -15z
m285 -10 c3 -5 2 -10 -4 -10 -6 0 -8 -6 -5 -13 2 -7 -2 -21 -9 -31 -12 -16
-11 -24 4 -55 17 -36 17 -36 -4 -43 -29 -8 -212 -10 -270 -2 -39 6 -44 9 -32
20 7 8 21 14 29 14 9 0 16 5 16 10 0 15 -68 12 -77 -4 -4 -7 -32 -16 -62 -19
-66 -8 -62 2 5 11 35 5 50 12 52 25 3 14 -4 17 -47 17 -44 0 -51 3 -51 19 0
24 45 32 150 27 45 -2 65 0 50 4 -14 5 -43 9 -65 10 -22 1 -49 5 -60 9 -11 5
20 6 70 3 50 -2 98 -9 109 -14 12 -7 22 -6 29 1 6 6 34 12 62 13 46 1 45 2
-20 8 l-70 6 97 2 c56 1 99 -2 103 -8z m-420 -20 c-11 -5 -27 -9 -35 -9 -9 0
-8 4 5 9 11 5 27 9 35 9 9 0 8 -4 -5 -9z m58 -127 c-7 -2 -21 -2 -30 0 -10 3
-4 5 12 5 17 0 24 -2 18 -5z"/>
<path d="M5078 6653 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z"/>
<path d="M5398 6623 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M5378 6583 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z"/>
<path d="M5030 6530 c-13 -8 -12 -10 3 -10 9 0 17 5 17 10 0 12 -1 12 -20 0z"/>
<path d="M4990 6500 c-8 -5 -10 -10 -5 -10 6 0 17 5 25 10 8 5 11 10 5 10 -5
0 -17 -5 -25 -10z"/>
<path d="M4025 5831 c-3 -6 -11 -9 -16 -6 -5 3 -6 -1 -3 -10 4 -11 2 -14 -9
-10 -8 4 -17 -1 -20 -9 -4 -9 -2 -16 3 -16 13 0 64 49 58 56 -3 3 -9 0 -13 -5z"/>
<path d="M3922 5785 c0 -16 2 -22 5 -12 2 9 2 23 0 30 -3 6 -5 -1 -5 -18z"/>
<path d="M3961 5754 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M3925 5739 c-11 -16 -1 -19 13 -3 7 8 8 14 3 14 -5 0 -13 -5 -16 -11z"/>
<path d="M3847 5663 c8 -3 11 -15 7 -31 l-5 -27 16 28 c17 29 31 37 21 12 -8
-21 1 -19 13 3 8 16 5 18 -27 19 -20 0 -31 -2 -25 -4z"/>
<path d="M3797 5583 c-4 -3 -7 -11 -7 -17 0 -6 5 -5 12 2 6 6 9 14 7 17 -3 3
-9 2 -12 -2z"/>
<path d="M3665 5550 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z"/>
<path d="M3812 5548 c-7 -7 -12 -17 -12 -24 0 -7 -6 -15 -12 -17 -8 -4 -9 -6
-2 -6 7 -1 19 11 29 25 18 28 16 41 -3 22z"/>
<path d="M3647 5523 c-4 -3 -7 -13 -7 -22 0 -8 -10 -25 -22 -38 -18 -19 -19
-23 -5 -23 13 0 57 68 57 87 0 6 -17 3 -23 -4z"/>
<path d="M3671 5484 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M3689 5428 c-1 -2 -2 -17 -4 -34 l-3 -32 28 32 c30 32 33 50 5 22
-20 -20 -29 -21 -21 -1 4 12 0 23 -5 13z"/>
<path d="M3710 5370 c-9 -16 -8 -18 5 -14 8 4 15 12 15 20 0 20 -7 17 -20 -6z"/>
<path d="M3565 5357 c-4 -10 -5 -21 -1 -24 10 -10 18 4 13 24 -4 17 -4 17 -12
0z"/>
<path d="M3683 5315 c-3 -9 -3 -18 -1 -21 3 -3 8 4 11 16 6 23 -1 27 -10 5z"/>
<path d="M3537 5303 c-4 -3 -7 -13 -7 -21 0 -12 3 -12 15 -2 8 7 15 16 15 21
0 11 -14 12 -23 2z"/>
<path d="M3570 5280 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0
-10 -4 -10 -10z"/>
<path d="M3512 5250 c0 -14 2 -19 5 -12 2 6 2 18 0 25 -3 6 -5 1 -5 -13z"/>
<path d="M3640 5234 c0 -8 5 -12 10 -9 6 3 10 10 10 16 0 5 -4 9 -10 9 -5 0
-10 -7 -10 -16z"/>
<path d="M3608 5219 c-3 -9 -3 -31 2 -50 5 -20 8 -25 9 -13 1 11 7 26 14 33 8
9 8 12 0 7 -7 -4 -13 2 -15 16 -2 18 -5 19 -10 7z"/>
<path d="M3501 5124 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M3560 5011 c0 -7 -6 -11 -14 -8 -11 4 -14 -2 -14 -24 1 -16 6 -32 11
-36 6 -3 7 -1 3 5 -4 6 1 23 10 37 9 14 14 28 10 32 -3 3 -6 1 -6 -6z"/>
<path d="M3415 4977 c-4 -10 -5 -21 -1 -24 10 -10 18 4 13 24 -4 17 -4 17 -12
0z"/>
<path d="M3391 4921 c-1 -27 2 -32 11 -23 8 8 8 17 0 34 -10 22 -11 21 -11
-11z"/>
<path d="M3525 4921 c-3 -5 -1 -12 5 -16 5 -3 10 1 10 9 0 18 -6 21 -15 7z"/>
<path d="M3421 4884 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M3491 4815 c0 -16 -4 -41 -6 -55 l-6 -25 11 25 c6 13 9 38 7 55 l-4
30 -2 -30z"/>
<path d="M3451 4814 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M3445 4750 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0
-7 -4 -4 -10z"/>
<path d="M3456 4715 c-9 -26 -7 -32 5 -12 6 10 9 21 6 23 -2 3 -7 -2 -11 -11z"/>
<path d="M3441 4664 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M3452 4620 c0 -14 2 -19 5 -12 2 6 2 18 0 25 -3 6 -5 1 -5 -13z"/>
<path d="M3336 4615 c4 -8 8 -15 10 -15 2 0 4 7 4 15 0 8 -4 15 -10 15 -5 0
-7 -7 -4 -15z"/>
<path d="M3310 4563 c0 -4 5 -15 10 -23 8 -13 10 -13 10 2 0 9 -4 20 -10 23
-5 3 -10 3 -10 -2z"/>
<path d="M3392 4370 c0 -14 2 -19 5 -12 2 6 2 18 0 25 -3 6 -5 1 -5 -13z"/>
<path d="M3411 4374 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M3382 4280 c0 -19 2 -27 5 -17 2 9 2 25 0 35 -3 9 -5 1 -5 -18z"/>
<path d="M3411 4294 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M3366 4220 c9 -45 14 -51 14 -15 0 16 2 26 5 23 7 -7 -13 -302 -22
-325 -6 -17 -6 -17 10 -1 14 13 17 39 19 135 l2 118 6 -120 c7 -119 7 -119 6
41 -1 138 -3 161 -16 159 -8 -1 -18 3 -22 9 -5 6 -5 -5 -2 -24z"/>
<path d="M3273 4190 c0 -25 2 -35 4 -22 2 12 2 32 0 45 -2 12 -4 2 -4 -23z"/>
<path d="M3272 4090 c0 -19 2 -27 5 -17 2 9 2 25 0 35 -3 9 -5 1 -5 -18z"/>
<path d="M3381 3860 c-1 -27 -4 -31 -11 -20 -8 13 -10 12 -10 -2 0 -22 18 -24
26 -4 3 8 4 25 1 38 -3 16 -5 13 -6 -12z"/>
<path d="M3400 3875 c0 -11 5 -27 10 -35 8 -12 10 -12 10 5 0 11 -5 27 -10 35
-8 12 -10 12 -10 -5z"/>
<path d="M3362 3695 c0 -16 2 -22 5 -12 2 9 2 23 0 30 -3 6 -5 -1 -5 -18z"/>
<path d="M3415 3680 c-3 -5 1 -10 10 -10 9 0 13 5 10 10 -3 6 -8 10 -10 10 -2
0 -7 -4 -10 -10z"/>
<path d="M3352 3610 c0 -14 2 -19 5 -12 2 6 2 18 0 25 -3 6 -5 1 -5 -13z"/>
<path d="M3441 3594 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M3343 3530 c0 -25 2 -35 4 -22 2 12 2 32 0 45 -2 12 -4 2 -4 -23z"/>
<path d="M3452 3545 c0 -16 4 -43 8 -60 11 -42 11 -1 1 50 -7 34 -9 35 -9 10z"/>
<path d="M3445 3450 c4 -25 8 -70 8 -100 0 -45 1 -49 7 -24 7 32 -5 153 -16
163 -4 3 -3 -14 1 -39z"/>
<path d="M3472 3440 c-1 -8 5 -42 12 -75 8 -33 14 -49 14 -35 0 28 -25 133
-26 110z"/>
<path d="M3440 3282 c0 -7 -7 -12 -15 -12 -16 0 -21 -25 -6 -34 9 -6 35 44 26
52 -3 3 -5 0 -5 -6z"/>
<path d="M3391 3225 c0 -35 2 -37 11 -19 7 15 7 28 -1 40 -9 16 -10 12 -10
-21z"/>
<path d="M3522 3210 c0 -14 2 -19 5 -12 2 6 2 18 0 25 -3 6 -5 1 -5 -13z"/>
<path d="M3423 3193 c-15 -5 -17 -23 -4 -23 5 0 11 7 15 15 3 8 4 15 3 14 -1
0 -8 -3 -14 -6z"/>
<path d="M3432 3115 c0 -16 2 -22 5 -12 2 9 2 23 0 30 -3 6 -5 -1 -5 -18z"/>
<path d="M3560 3040 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0
-10 -4 -10 -10z"/>
<path d="M3603 2970 c-1 -22 2 -40 7 -40 4 0 6 10 4 23 -3 13 3 7 16 -16 16
-30 19 -42 10 -52 -9 -11 -7 -14 9 -12 26 2 27 -1 -12 75 l-33 63 -1 -41z"/>
<path d="M3621 2904 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M3570 2860 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0
-10 -4 -10 -10z"/>
<path d="M3535 2840 c3 -5 10 -10 16 -10 5 0 9 5 9 10 0 6 -7 10 -16 10 -8 0
-12 -4 -9 -10z"/>
<path d="M3591 2824 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M3686 2795 c-3 -8 -1 -17 3 -20 5 -3 11 2 15 10 3 8 1 17 -3 20 -5 3
-11 -2 -15 -10z"/>
<path d="M3701 2750 c-1 -18 16 -46 23 -40 2 3 -2 16 -9 30 -8 15 -14 19 -14
10z"/>
<path d="M3736 2727 c3 -10 9 -15 12 -12 3 3 0 11 -7 18 -10 9 -11 8 -5 -6z"/>
<path d="M3765 2635 c0 -30 3 -48 7 -41 7 13 5 82 -3 90 -2 2 -4 -20 -4 -49z"/>
<path d="M3795 2602 c3 -51 3 -52 16 -52 8 0 8 5 -1 15 -10 12 -10 15 3 15 9
0 18 -8 21 -17 4 -10 16 -29 27 -43 19 -23 19 -22 -2 15 -12 22 -28 47 -36 56
-7 8 -13 21 -13 27 0 6 -4 13 -9 16 -4 3 -7 -11 -6 -32z"/>
<path d="M3748 2553 c-10 -2 -18 -9 -18 -14 0 -14 20 -11 36 6 16 15 13 16
-18 8z"/>
<path d="M3842 2498 c2 -16 6 -24 11 -19 5 5 5 17 -2 28 -9 16 -10 15 -9 -9z"/>
<path d="M3751 2484 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M3920 2431 c0 -6 4 -13 10 -16 6 -3 7 1 4 9 -7 18 -14 21 -14 7z"/>
<path d="M3825 2360 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0
-7 -4 -4 -10z"/>
<path d="M4000 2331 c0 -10 29 -36 34 -30 1 2 -6 12 -16 22 -10 9 -18 13 -18
8z"/>
<path d="M3911 2284 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M4007 2269 c7 -7 15 -10 18 -7 3 3 -2 9 -12 12 -14 6 -15 5 -6 -5z"/>
<path d="M4045 2260 c3 -5 11 -10 16 -10 6 0 7 5 4 10 -3 6 -11 10 -16 10 -6
0 -7 -4 -4 -10z"/>
<path d="M4086 2195 c4 -8 11 -15 16 -15 6 0 5 6 -2 15 -7 8 -14 15 -16 15 -2
0 -1 -7 2 -15z"/>
<path d="M3960 2191 c0 -5 9 -11 20 -14 24 -6 27 8 4 17 -21 8 -24 8 -24 -3z"/>
<path d="M4163 2140 c-1 -13 3 -17 13 -13 19 7 18 -7 -3 -22 -17 -12 -11 -35
10 -35 7 0 6 4 -3 10 -16 10 -14 12 13 27 16 8 16 11 -6 31 -22 21 -23 21 -24
2z"/>
<path d="M4038 2143 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z"/>
<path d="M4113 2063 c9 -2 23 -2 30 0 6 3 -1 5 -18 5 -16 0 -22 -2 -12 -5z"/>
<path d="M4270 2051 c0 -5 5 -13 10 -16 6 -3 10 -2 10 4 0 5 -4 13 -10 16 -5
3 -10 2 -10 -4z"/>
<path d="M4328 1993 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M4427 1919 c7 -7 15 -10 18 -7 3 3 -2 9 -12 12 -14 6 -15 5 -6 -5z"/>
<path d="M4290 1880 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0
-4 -4 -4 -10z"/>
<path d="M4745 1738 c5 -13 45 -42 50 -36 1 2 -11 13 -26 26 -16 13 -27 17
-24 10z"/>
<path d="M4870 1680 c8 -5 20 -10 25 -10 6 0 3 5 -5 10 -8 5 -19 10 -25 10 -5
0 -3 -5 5 -10z"/>
<path d="M4808 1673 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M5000 1635 c14 -8 30 -14 35 -14 6 0 -1 6 -15 14 -14 8 -29 14 -35
14 -5 0 1 -6 15 -14z"/>
<path d="M6856 5755 c-3 -9 0 -15 9 -15 9 0 12 6 9 15 -4 8 -7 15 -9 15 -2 0
-5 -7 -9 -15z"/>
<path d="M6965 5721 c-3 -6 -3 -16 0 -21 4 -6 1 -19 -7 -28 -11 -15 -11 -16 3
-4 9 7 23 10 32 6 26 -9 28 12 3 35 -15 15 -26 19 -31 12z m35 -33 c0 -6 -6
-5 -15 2 -8 7 -15 14 -15 16 0 2 7 1 15 -2 8 -4 15 -11 15 -16z"/>
<path d="M6905 5660 c4 -6 11 -8 16 -5 14 9 11 15 -7 15 -8 0 -12 -5 -9 -10z"/>
<path d="M6945 5631 c-3 -5 -1 -12 5 -16 5 -3 10 1 10 9 0 18 -6 21 -15 7z"/>
<path d="M7040 5611 c0 -10 19 -25 25 -20 1 2 -3 10 -11 17 -8 7 -14 8 -14 3z"/>
<path d="M6982 5558 c5 -15 28 -23 28 -10 0 5 -7 13 -16 16 -10 4 -14 1 -12
-6z"/>
<path d="M7030 5544 c0 -8 5 -12 10 -9 6 4 8 11 5 16 -9 14 -15 11 -15 -7z"/>
<path d="M7120 5542 c0 -12 39 -60 40 -49 0 5 -9 20 -20 34 -11 14 -20 21 -20
15z"/>
<path d="M7031 5501 c-19 -12 -5 -31 22 -30 17 1 18 2 5 6 -34 9 -18 23 25 22
36 -1 38 -2 17 -9 l-25 -8 28 -1 c19 -1 27 3 25 12 -5 14 -77 21 -97 8z"/>
<path d="M5760 5162 c0 -5 19 -34 43 -64 23 -31 47 -63 52 -72 9 -15 15 -15
45 -5 19 7 43 18 53 25 17 11 17 13 -9 38 -57 52 -184 106 -184 78z"/>
<path d="M5955 5137 c16 -12 36 -30 44 -39 19 -23 43 -23 39 -1 -2 9 -23 27
-48 39 -57 30 -74 30 -35 1z"/>
<path d="M5631 5118 c-5 -13 -21 -38 -35 -57 -14 -18 -28 -48 -32 -65 -3 -17
-10 -35 -14 -41 -4 -5 -10 -29 -12 -52 -4 -52 2 -53 78 -15 l55 27 -5 65 c-3
36 -6 86 -6 113 0 50 -15 62 -29 25z"/>
<path d="M5700 5138 c-7 -45 -7 -178 0 -178 5 0 7 -7 4 -15 -4 -8 -4 -15 0
-15 16 0 116 56 116 65 0 26 -117 165 -120 143z m7 -140 c-3 -7 -5 -2 -5 12 0
14 2 19 5 13 2 -7 2 -19 0 -25z"/>
<path d="M6164 4696 c-6 -7 -19 -44 -29 -82 -9 -38 -23 -82 -30 -99 -7 -16
-17 -41 -21 -55 -7 -24 -6 -24 18 5 32 38 41 57 67 130 30 85 27 139 -5 101z"/>
<path d="M6048 4647 l-48 -22 0 -117 c0 -65 -4 -118 -8 -118 -5 0 -7 37 -4 83
2 45 -1 94 -7 109 -10 25 -12 27 -43 17 -18 -6 -73 -30 -123 -54 -49 -23 -100
-45 -112 -49 -13 -4 -23 -12 -23 -18 0 -18 60 -66 113 -91 86 -40 123 -50 146
-37 20 10 19 12 -19 46 -21 20 -52 55 -67 80 -15 24 -31 44 -35 44 -5 0 -8 5
-8 10 0 17 18 11 25 -9 3 -10 31 -46 63 -80 65 -69 102 -79 139 -38 26 28 60
124 71 199 12 78 12 78 -60 45z"/>
<path d="M5620 4453 l-35 -14 25 -20 c47 -36 110 -67 157 -78 64 -13 77 2 22
27 -25 11 -65 38 -90 60 -44 40 -45 40 -79 25z"/>
<path d="M7360 5144 c0 -6 7 -19 16 -30 14 -18 14 -18 3 6 -14 31 -19 36 -19
24z"/>
<path d="M7361 5074 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M7321 5014 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M7400 4998 c0 -18 18 -34 28 -24 3 4 -2 14 -11 23 -16 16 -17 16 -17
1z"/>
<path d="M7355 4960 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0
-7 -4 -4 -10z"/>
<path d="M7441 4944 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M7456 4896 c4 -11 2 -21 -7 -27 -10 -6 -11 -9 -1 -9 18 0 27 29 13
43 -9 9 -11 8 -5 -7z"/>
<path d="M7391 4833 c-1 -24 3 -43 8 -43 5 0 16 -18 25 -40 9 -22 20 -40 26
-40 17 0 11 22 -11 46 -11 12 -27 44 -34 70 l-13 49 -1 -42z"/>
<path d="M7470 4846 c0 -9 5 -16 10 -16 6 0 10 4 10 9 0 6 -4 13 -10 16 -5 3
-10 -1 -10 -9z"/>
<path d="M7440 4833 c0 -5 7 -17 15 -27 8 -11 15 -30 15 -42 0 -28 21 -46 40
-34 12 7 12 12 -3 27 -10 12 -14 27 -10 41 3 13 1 22 -6 22 -5 0 -8 -7 -5 -15
4 -8 3 -15 0 -15 -4 0 -11 11 -16 25 -9 23 -30 36 -30 18z"/>
<path d="M7430 4801 c0 -5 5 -13 10 -16 6 -3 10 -2 10 4 0 5 -4 13 -10 16 -5
3 -10 2 -10 -4z"/>
<path d="M7528 4655 c2 -14 6 -25 8 -25 2 0 4 11 4 25 0 14 -4 25 -9 25 -4 0
-6 -11 -3 -25z"/>
<path d="M7552 4560 c0 -19 2 -27 5 -17 2 9 2 25 0 35 -3 9 -5 1 -5 -18z"/>
<path d="M7501 4534 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M7561 4494 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M7301 2920 c-5 -16 -8 -30 -6 -30 2 0 10 14 19 30 8 17 11 30 6 30
-4 0 -13 -13 -19 -30z"/>
<path d="M7300 2870 c-9 -6 -10 -10 -3 -10 6 0 15 5 18 10 8 12 4 12 -15 0z"/>
<path d="M7155 2800 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z"/>
<path d="M7237 2775 c3 -8 9 -12 14 -9 12 7 11 11 -5 17 -10 4 -13 1 -9 -8z"/>
<path d="M4858 3383 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z"/>
<path d="M4854 3356 c-3 -7 -4 -38 -2 -67 3 -53 3 -54 35 -54 17 0 29 -3 26
-7 -8 -14 14 -8 27 7 22 26 23 82 3 109 -20 28 -80 36 -89 12z"/>
<path d="M4858 3213 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M5076 3325 c-33 -30 -33 -60 0 -90 25 -23 44 -24 72 -2 13 11 16 75
4 95 -15 23 -50 22 -76 -3z"/>
<path d="M5528 1403 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
</g>
</svg>

    </Box>
  );
  if (disabledLink) {
    return <>{logo}</>;
  }

  return <RouterLink to="">{logo}</RouterLink>
}
